export default "__VITE_PUBLIC_ASSET__593097a5__"